import { authFetch } from "./FetchUtil";
import { SkitterBookSessionAccountConversionResult } from "../Models/SkitterBookSessionAccountConversionResult";

export async function convertSessionToAccountSkitterbooks() {
    const response = await authFetch("/api/home/sessiontoaccount", {
        method: "POST"
    });

    if (!response.ok) {
        throw new Error(`Failed to convert session: ${response.status}`);
    }

    return response.json() as Promise<SkitterBookSessionAccountConversionResult>;
}
